var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDarkMode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "860.000000pt",
    height: "900.000000pt",
    viewBox: "0 0 860.000000 900.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,900.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4030 8584 c-1140 -86 -2181 -638 -2872 -1524 -452 -581 -722 -1232 -820 -1977 -18 -141 -22 -218 -22 -478 -1 -314 10 -459 50 -685 196 -1112 824 -2064 1764 -2675 814 -529 1786 -741 2755 -600 721 105 1381 396 1955 863 135 110 442 417 552 552 685 842 996 1888 883 2967 -94 896 -497 1741 -1136 2383 -645 649 -1461 1045 -2379 1155 -130 16 -605 28 -730 19z m-889 -1580 c-71 -321 -79 -754 -20 -1104 192 -1145 1023 -2081 2134 -2406 288 -84 528 -117 850 -117 251 -1 401 13 593 54 52 11 96 18 99 16 15 -16 -175 -342 -286 -491 -618 -822 -1624 -1228 -2641 -1065 -1011 161 -1858 889 -2175 1870 -309 956 -67 2001 636 2743 149 158 361 329 550 444 87 53 272 152 277 148 1 -2 -6 -43 -17 -92z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkMode);
export default __webpack_public_path__ + "static/media/Dark-Mode.088081197135e1bcdbd227f82188560f.svg";
export { ForwardRef as ReactComponent };